'use client'
import { ContactUsForm } from '@/components'
import Link from 'next/link'
import React from 'react'

function ContactUsPage() {
   return (
      <>
         <section className="portfolio-template-subPage section_secondary_bg first-section">
            <div className="container text-center">
               <div className="portfolio_breadCrumb mb-4">
                  <Link href="/" className="d-inline">
                     Home
                  </Link>
                  <img
                     className="mx-2"
                     height="10"
                     width="10"
                     src="/assets/svg/two-right-icon.svg"
                  />
                  <span> Contact Us</span>
               </div>
               <h1 className="intro_title tech_title mb-3">
                  We’ll Be Glad To Assist You!
               </h1>
               <p className="section_desc">
                  Want to inquire more about us? Let’s discuss the details about
                  your dream project.
               </p>
            </div>
         </section>
         <ContactUsForm isContactUSPage={true} />

         <div className="p-0 section_primary_bg">
            <iframe
               src="https://maps.google.com/maps?q=Benzatine%20Infotech%2C%20opp.%20Gajera%20School%2C%20Chitrakut%20Society%2C%20Katargam%2C%20Surat%2C%20Gujarat&amp;t=m&amp;z=12&amp;output=embed&amp;iwloc=near"
               aria-label="Benzatine Infotech, opp. Gajera School, Chitrakut Society, Katargam, Surat, Gujarat"
               title="Benzatine Infotech, opp. Gajera School, Chitrakut Society, Katargam, Surat, Gujarat"
               width="100%"
               height="500"
               loading="lazy"
            ></iframe>
         </div>
      </>
   )
}

export default ContactUsPage
